module.exports = __webpack_public_path__ + "static/media/crocodile(4).2d68703b.PNG";